
class SupplierNoteDetailViewController extends NoteDetailViewController
{
    private allReceiptButton:MUIButton = null;

    private noEditHeaderView:SupplierNoteDetailHeader = null;
    private editHeaderView:SupplierNoteDetailHeader = null;

    private warehouseLabel:MUILabel = null;
    private warehouseButton:MUIButton = null;

    private titleView:MUIView = null;
    private titleViewNoQuantityView:MUIView = null;
    private uploadButton:MUIButton = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.allReceiptButton = MUIOutlet(this, "all-received-btn", "MUIButton");
        this.allReceiptButton.setAction(this, function(){
            this.markAllAsReceivedAction();
        });

        this.noEditHeaderView = MUIOutlet(this, "no-edit-header-view", "SupplierNoteDetailHeader");
        this.editHeaderView = MUIOutlet(this, "edit-header-view", "SupplierNoteDetailHeader");

        this.warehouseLabel = MUIOutlet(this, "warehouse-lbl", "MUILabel");
        this.warehouseButton = MUIOutlet(this, "warehouse-btn", "MUIButton");
        this.setupWarehouseButton( this.warehouseButton, this, function (this:SupplierNoteDetailViewController, controller:SelectEntityViewController, warehouse:Warehouse) {
            this.stockNote.overrideWarehouse = warehouse;
            this.stockNote.overrideWarehouseName = warehouse != null ? warehouse.name : MIOLocalizeString("PRODUCT_DEFAULT_WAREHOUSE", "PRODUCT DEFAULT WAREHOUSE");
            this.warehouseLabel.text = this.stockNote.overrideWarehouseName;
            this.applyOverrideWarehose(warehouse);
        });

        this.searchTextField = MUIOutlet(this, "search-bar", "MUITextField");
        this.setupSearchTextField();

        this.titleView = MUIOutlet(this, "titlebar", "MUIView");
        this.titleViewNoQuantityView = MUIOutlet(this, "titlebar-no-orderquantity", "MUIView");

        this.uploadButton = MUIOutlet(this, "upload-btn", "MUIButton");
        this.uploadButton.setAction(this, function(this:SupplierNoteDetailViewController){
            this.openUploadPanel();
        });
    }

    private openUploadPanel(){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let panel = MUIOpenPanel.openPanel();
        panel.allowedFileTypes = ["pdf", "png", "jpg", "jpeg"];
        panel.beginSheetModalForWindow(ad.window, this, function(this:SupplierNoteDetailViewController, result:number){
            if (result != MIOFileHandlingPanel.OKButton) return;
            let file = panel.files[0];
            if (file == null) return;
            ad.webService.uploadSupplierNoteFile(this.stockNote, file, function(code:number, data:any){
                if (code == 200) {
                    AppHelper.showInfoMessage(null, MIOLocalizeString("SUCCESS", "SUCCESS"), MIOLocalizeString("FILE_UPLOADED_SUCCESSFULLY", "File uploaded successfully."));
                } else {
                    AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("COULDNT_UPLOAD_FILE", "Couldn't upload file. Please try again."));
                }
            });
        });
    }

    protected updateUI(){        
        this.allReceiptButton.hidden = this.stockNote.status == StockNoteStatus.Pending ? false : true;
        
        this.editHeaderView.note = this.stockNote;
        this.noEditHeaderView.note = this.stockNote;

        this.editHeaderView.hidden = this.stockNote.status == StockNoteStatus.Processed ? true : false;
        this.noEditHeaderView.hidden = this.stockNote.status == StockNoteStatus.Processed ? false : true;

        this.editHeaderView.delegate = this;
        this.noEditHeaderView.delegate = this;
        
        this.warehouseLabel.text = this.stockNote.overrideWarehouseName ?? MIOLocalizeString("PRODUCT_DEFAULT_WAREHOUSE", "PRODUCT DEFAULT WAREHOUSE");
        this.warehouseButton.hidden = this.stockNote.status == StockNoteStatus.Processed ? true : false;

        this.titleView.hidden = this.stockNote.status == StockNoteStatus.None ? true : false;
        this.titleViewNoQuantityView.hidden = this.stockNote.status == StockNoteStatus.None ? false : true;
        
        this.invalidateData();
        this.tableView.reloadData();
    

        // detected lines block (document extraction)
        if (this.extractionSession == null) this.extractionSession = DocumentExtractionSession.attach(this, this.stockNote, this);
        else this.extractionSession.setDocument(this.stockNote);
    }

    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
        
        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = this.stockNote.status == StockNoteStatus.None ? 
                [MIOSortDescriptor.sortDescriptorWithKey('orderIndex', true)] 
                : [MIOSortDescriptor.sortDescriptorWithKey('productName', true)];

        let predicateFormat = 'note.identifier == ' + this.stockNote.identifier;
        if (this.searchString != null) {
            predicateFormat += " AND productName CONTAINS '" + this.searchString + "'";
        }

        let fetchRequest = DBHelper.listFetchRequestWithEntityName("SupplierNoteLine", sortDescriptors, predicateFormat);
        fetchRequest.relationshipKeyPathsForPrefetching = ["tax", "taxBuy", "inputFormat", "product", "product.defaultWarehouse", "product.supplierProducts"];
        
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
    
    // controllerDidChangeContent(controller:MIOFetchedResultsController){
    //     super.controllerDidChangeContent(controller);
    //     this.updateTotal();        
    // }

    //
    // NoteLine Delegate
    //

    supplierFromNote(sender){
        return this.stockNote.originEntity;
    }
    
    private markAllAsReceivedAction(){
        let lines = this.fetchedResultsController.fetchedObjects;
        for (let index = 0; index < lines.length; index++){
            let l = lines[index] as StockNoteLine;
            l.quantity = l.estimatedQuantity;
            l.price = l.estimatedPrice;
                        
            // [l.productQuantity, l.measureQuantity] = DBHelper.calculateQuantityFromStockLine(l.quantity, l.inputFormat, l.measureType, l.productMeasureType, l.productContainerMeasureType, l.productContainerQuantity);        
            // [l.total, l.discountValue] = DBHelper.calculateTotalFromStockLine(l.quantity, l.price, l.discountString);    
        }
        
        DBHelper.saveMainContext();        
    }

    protected setupWarehouseButton(button:MUIButton, target, completion){
        if (button == null) return;
        button.setAction(this, function(){
            AppHelper.sharedInstance().showSelectWarehouseViewControllerFromView(button, this.stockNote.overrideWarehouse, true, false, target, completion);
        });   
    }

    private applyOverrideWarehose(warehouse:Warehouse) {
        for (let index = 0; index < this.fetchedResultsController.fetchedObjects.length; index++) {
            let line = this.fetchedResultsController.objectAtIndexPath(MIOIndexPath.indexForRowInSection(index, 0)) as SupplierNoteLine;
            
            if (warehouse != null) {
                line.warehouse = warehouse;
                line.warehouseName = warehouse.name;
            }
            else if (line.product.defaultWarehouse != null){ 
                line.warehouse = line.product.defaultWarehouse;
                line.warehouseName = line.product.defaultWarehouse.name;
            }
            else {
                line.warehouse = AppHelper.sharedInstance().defaultWarehouse;
                line.warehouseName = AppHelper.sharedInstance().defaultWarehouse?.name;
            }
        }
        DBHelper.saveMainContext();
        // this.tableView.reloadData();
    }    

    overrideWarehouse() : Warehouse {
        return this.stockNote.overrideWarehouse;
    }

    protected customActionsForStatus(status:StockNoteStatus) : any[]{
        
        let actions = [];

        if (status == StockNoteStatus.None || status == StockNoteStatus.Pending || status == StockNoteStatus.Unprocessed){
            let deleteItem = {"Type": "Action", "Action": this.recalulateAction};
            actions.addObject(deleteItem);
        }

        if (status == StockNoteStatus.Processed) {
            let item = {"Type": "Action", "Action" : this.invoiceAction};
            actions.addObject(item);
        }

        if (status == StockNoteStatus.None || status == StockNoteStatus.Pending || status == StockNoteStatus.Unprocessed) {
            actions.addObject({"Type": "Action", "Action": this.extractDocumentAction});
        }

        for (let i of super.customActionsForStatus(status)) actions.addObject(i);

        return actions;
    }

    get invoiceAction(){
        return MUIAlertAction.alertActionWithTitle(MIOLocalizeString("GENERATE_PURCHASE_INVOICE", "GENERATE PURCHASE INVOICE"), MUIAlertActionStyle.Default, this, function(){        
            this.showInvoiceFields();
        });   
    }

    private showInvoiceFields() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("PLEASE_FILL_THE_REQUIRED_INFO", "PLEASE FILL THE REQUIRED INFO"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler( this, function(this:SupplierNoteDetailViewController, textField:MUITextField) {
            if (this.stockNote.externalReference != null) textField.text = this.stockNote.externalReference;
            else textField.placeholderText = MIOLocalizeString("DOCUMENT_NUMBER", "DOCUMENT NUMBER");
        });

        avc.addTextFieldWithConfigurationHandler( this, function(this:SupplierNoteDetailViewController, textField:MUITextField) {
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            if (this.stockNote.stockDate != null) textField.text = ad.dateTimeFormatter.stringFromDate( this.stockNote.stockDate );
            else textField.placeholderText = MIOLocalizeString("DOCUMENT_DATE", "DOCUMENT DATE");
        });

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Default, this, function(this:SupplierNoteDetailViewController){
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            let ref = avc.textFields[0].text;
            let date = ad.dateTimeFormatter.dateFromString(avc.textFields[1].text);

            this.generateInvoice(ref, date);
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Default, null, null) );

        this.presentViewController(avc, true);
    }

    private generateInvoice(reference:string, date:Date){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.createInvoiceFromMultipleSupplierNotes([this.stockNote], this.stockNote.originEntity as Supplier, reference, date, (result:boolean) => {
            if (result) AppHelper.showInfoMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("THE_INVOICE_WAS_CREATED", "THE INVOICE WAS CREATED"));
            else AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("SOMETHING_WENT_WRONG", "SOMETHING WENT WRONG!"));
        });
    }

    // Document extraction (DLInsightsBotServer): read the attached file, then review the proposal.
    get extractDocumentAction(){
        return MUIAlertAction.alertActionWithTitle(MIOLocalizeString("EXTRACT_DOCUMENT", "EXTRACT DOCUMENT"), MUIAlertActionStyle.Default, this, function(this:SupplierNoteDetailViewController){
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            ad.webService.runDocumentExtraction("SupplierNote", this.stockNote.identifier, (code:number, data:any) => {
                if (code == 200) AppHelper.showInfoMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("THE_DOCUMENT_IS_BEING_READ", "The document is being read. Open REVIEW EXTRACTION in a minute."));
                else AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("COULDNT_START_THE_EXTRACTION", "Couldn't start the extraction."));
            });
        });
    }

    // Detected lines of the note read by DLInsightsBotServer (block in the layout), refreshed with the note.
    private extractionSession:DocumentExtractionSession = null;

    // DocumentExtractionSessionDelegate
    extractionSessionDidInsertLine(session:DocumentExtractionSession, line:StockNoteLine){
        this.computeTotals();
        DBHelper.saveMainContext();
    }

    extractionSessionDidFinish(session:DocumentExtractionSession){
        this.computeTotals();
        DBHelper.saveMainContext();
    }

    get recalulateAction(){
        return MUIAlertAction.alertActionWithTitle(MIOLocalizeString("RECALCULATE_TOTALS", "RECALCULATE TOTALS"), MUIAlertActionStyle.Default, this, function(this:SupplierNoteDetailViewController){
            this.recalculateTotals();
        });
    }

    private recalculateTotals(){
        this.checkTotals();
        DBHelper.saveMainContext();
    }
}